import { useMiscIntercomStore } from '~/stores/miscIntercom'

type IntercomPositionSetFunction = (move: () => void) => void

export const defaultMountCall: IntercomPositionSetFunction = (moveUp) =>
  moveUp()
export const defaultUnmountCall: IntercomPositionSetFunction = (moveDown) =>
  moveDown()

/**
 * By default: bumps the `intercom` widget up on mount and down on unmount.
 *
 * @param mountCallback - Override the onMount behavior function.
 * @param unmountCall - Override the onUnmount behavior function.
 */
export function useIntercomMove(
  mountCallback = defaultMountCall,
  unmountCall = defaultUnmountCall,
) {
  const { SET, RESET } = useMiscIntercomStore()

  onMounted(() => mountCallback(SET))
  onBeforeUnmount(() => unmountCall(RESET))
}
